import {userService} from "@/_services";
import {signaturesService} from "../../_services/signatures.service";
import router from "@/router";

export default {
  getAll({dispatch, commit}, {page, sort, company_id, search}) {
    userService.getAll(page, sort, company_id, search)
      .then(
        users => {
          commit("setUsersData", users)
          return Promise.resolve(users);
        },
        error => {
          dispatch("alert/error", error, { root: true });
        }
      )
  },
  inviteUser({dispatch, commit}, {user, company_id}) {
    dispatch('alert/clear', {}, {root: true});
    return userService.inviteUser(user, company_id)
      .then(
        user => {
          dispatch('alert/success', "Se envió la invitación con éxito.", { root: true });
          dispatch('users/getAll', {page: 0, company_id}, { root: true });
          return Promise.resolve(user);
        },
        error => {
          dispatch("alert/error", error, { root: true });
          return Promise.reject(error);
        }
      )
  },
  delete({dispatch, commit}, {user_id, company_id}) {
    dispatch('alert/clear', {}, {root: true});
    return userService.delete(user_id, company_id)
      .then(
        () => {
          dispatch('alert/success', "Se ha expulsado el usuario con éxito.", { root: true });
          dispatch('users/getAll', {page: 0, company_id}, { root: true });
          return Promise.resolve();
        },
        error => {
          dispatch("alert/error", error, { root: true });
          return Promise.reject(error);
        }
      )
  },
  promoteRole({dispatch, commit}, {user_id, company_id, role, aclChangeRole}) {
    dispatch('alert/clear', {}, {root: true});
    return userService.promoteRole(user_id, company_id, role)
      .then(
        () => {
          dispatch('alert/success', "Se ha cambiado el acceso al usuario con éxito.", { root: true });
          dispatch('users/getAll', {page: 0, company_id}, { root: true });
          dispatch("account/me", {aclChangeRole}, {root:true});
          return Promise.resolve();
        },
        error => {
          dispatch("alert/error", error, { root: true });
          return Promise.reject(error);
        }
      )
  },
  remoteEmailValidation({dispatch, commit}, {email}) {
    return signaturesService.remoteEmailValidation(email)
      .then(
        () => {
          return Promise.resolve();
        },
        error => {
          return Promise.reject(error);
        }
      )
  }
}
